@if (inputFormControl.invalid && ((!skipdirty && inputFormControl.dirty) || inputFormControl.touched)) {
  <!-- MIN length message -->
  @if (inputFormControl.errors?.['minlength']) {
    <div class="invalid-feedback d-block"
      [translateParams]="{MinLengthNumber:$safeNavigationMigration(inputFormControl.errors?.['minlength'].requiredLength)}"
      translate="Error.MinLength">
    </div>
  }
  <!-- MAX length message -->
  @if (inputFormControl.errors?.['maxlength']) {
    <div class="invalid-feedback d-block"
      [translateParams]="{MaxLengthNumber:$safeNavigationMigration(inputFormControl.errors?.['maxlength'].requiredLength)}"
      translate="Error.MaxLength">
    </div>
  }
  <!-- Required message -->
  @if (inputFormControl.errors?.['required']) {
    <div class="invalid-feedback d-block" translate="Error.Required">
    </div>
  }
  <!-- Contains Forbidden 'Word' (string) -->
  @if (inputFormControl.errors?.['containsForbiddenWord']) {
    <div class="invalid-feedback d-block"
      translate="Error.ContainsForbiddenWord"
      [translateParams]="{ForbiddenWord:$safeNavigationMigration(inputFormControl.errors?.['containsForbiddenWord'].forbiddenWord)}">
    </div>
  }
  <!-- Minimum "Word" count -->
  @if (inputFormControl.errors?.['shortComingOnWords']) {
    <div class="invalid-feedback d-block"
      translate="Error.ShortComingOnWords"
      [translateParams]="{MinimumCount:$safeNavigationMigration(inputFormControl.errors?.['shortComingOnWords'].minimum)}">
    </div>
  }
  <!--Only letters and number pattern validation  -->
  @if (inputFormControl.errors?.['OnlyLettersAndCharactersAllowed']) {
    <div class="invalid-feedback d-block"
      translate="Error.OnlyLettersAndNumbersAllowed">
    </div>
  }
  <!--Only numbers pattern validation  -->
  @if (inputFormControl.errors?.['OnlyNumbersAllowed']) {
    <div class="invalid-feedback d-block"
      translate="Error.OnlyNumbersAllowed">
    </div>
  }
  <!--Does not pass our Email Validation  -->
  @if (inputFormControl.errors?.['IsNotEmail']) {
    <div class="invalid-feedback d-block" translate="Error.IsNotEmail">
    </div>
  }
  <!--Does not pass our Phonenumber Validation  -->
  @if (inputFormControl.errors?.['IsNotPhonenumber']) {
    <div class="invalid-feedback d-block"
      translate="Error.IsNotPhonenumber">
    </div>
    } <!--Does not pass THE Phonenumber INPUT Validation  -->
    @if (inputFormControl.errors?.['validatePhoneNumber']) {
      <div class="invalid-feedback d-block"
        translate="Error.IsNotPhonenumber">
      </div>
    }
    <!--Does not pass our Password Validation  -->
    @if (inputFormControl.errors?.['IsNotAcceptedPassword']) {
      <div class="invalid-feedback d-block"
        translate="Error.IsNotAcceptedPassword">
      </div>
    }
    <!-- Cannot contain only WhiteSpace -->
    @if (inputFormControl.errors?.['cannotContainSpace']) {
      <div class="invalid-feedback d-block"
        translate="Error.RequiredNoWhiteSpace">
      </div>
    }
    <!-- Is Not Equal To -->
    @if (inputFormControl.errors?.['IsNotEqual']) {
      <div class="invalid-feedback d-block"
        translate="Error.IsNotEqual">
      </div>
    }
  }